import React, { useState, useEffect } from "react";
// import { BASE_URL } from "../_globalConstants.js";

export default function AdminList() {
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(true);

    const [orgData, setOrgData] = useState([]);
    const [selectedOrg, setSelectedOrg] = useState(null);

    useEffect(() => {
        if (successMessage) {
            setTimeout(() => setSuccessMessage(false), 3000);
        }
        if (errorMessage) {
            setTimeout(() => setErrorMessage(false), 3000);
        }
    }, [successMessage, errorMessage]);

    useEffect(() => {
        // Fetch the organization data when the component mounts
        async function fetchOrganizationData() {
            try {
                setLoading(true);
                const response = await fetch("/api/admin/company");
                // console.log("Response from server:", response);
                if (response.ok) {
                    // Check if the response is actually JSON
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.includes("application/json")) {
                        const data = await response.json();
                        // console.log("Organization data:", data.results || data);
                        setOrgData(data.results || data);
                        if (data.results.length > 0) {
                            setSelectedOrg(data.results[0]);
                        }
                    } else {
                        // Response is not JSON, likely an HTML error page
                        const textData = await response.text();
                        console.error("Expected JSON but received:", textData.substring(0, 200));
                        setErrorMessage("Server returned unexpected response format. Check if the API endpoint exists.");
                    }
                } else {
                    const errorText = await response.text();
                    console.error("Server error:", response.status, errorText);
                    setErrorMessage(`Failed to fetch organization data. Status: ${response.status}`);

                }
            } catch (error) {
                console.error("Failed to fetch organization data.", error);
                setErrorMessage(`Network error: ${error.message}`);
            }
            setLoading(false);
        }
        fetchOrganizationData();
    }, []);

    function Popup({ message, onClose, error }) {
        return (
            <div className={error ? "popup error-popup" : "popup success-popup"}>
                <div className="popup-content">
                    <p>{message}</p>
                    <span className="close" onClick={onClose}>&times;</span>
                </div>
            </div>
        );
    }

    return (
        <div className="admin-list-container">
            {loading &&
                <div>
                    Loading...
                </div>
            }
            {successMessage && <Popup message={successMessage} onClose={() => setSuccessMessage(false)} error={false} />}
            {errorMessage && <Popup message={errorMessage} onClose={() => setErrorMessage(false)} error={true} />}
            <div className="org-list">
                {orgData.map((org, index) => (
                    <div
                        key={org.company_id || index}
                        className={`org-item ${selectedOrg && selectedOrg.company_id === org.company_id ? "selected" : ""}`}
                        onClick={() => setSelectedOrg(org)}
                    >
                        {org.company_name}
                    </div>
                ))}
            </div>
            {selectedOrg && (
                <div className="org-details">
                    <h3>Organization Details</h3>
                    <p><strong>Name:</strong> {selectedOrg.company_name}</p>
                    <p><strong>ID:</strong> {selectedOrg.company_id}</p>
                    <p><strong>Primary POC:</strong> {selectedOrg.company_primary_poc}</p>
                    <p><strong>Email:</strong> {selectedOrg.company_primary_poc_email}</p>
                </div>
            )}

            {/* DEBUGGING */}
            {/* <div>{JSON.stringify(orgData)}</div> */}
        </div>
    );
    }